import { render, staticRenderFns } from "./SpinLoader.vue?vue&type=template&id=027e7d07&scoped=true&"
import script from "./SpinLoader.vue?vue&type=script&lang=ts&"
export * from "./SpinLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SpinLoader.vue?vue&type=style&index=0&id=027e7d07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e7d07",
  null
  
)

export default component.exports